import { controlDefaults } from "../../../core/form/lib/validateForm";

export const controls = {
  id: {
    ...controlDefaults,
    name: 'id',
    type: 'hidden',
  },
  name:{
    ...controlDefaults,
    placeholder: '',
    name: 'name',
    type: 'text',
    caption: 'Organisation',
    description: 'Name of organisation that own/lease the properties. This is a required Field',
    validationRules: {
      isRequired: true
    },
    disabled: true
  },
  default_property_id:{
    ...controlDefaults,
    placeholder: '',
    name: 'default_property_id',
    type: 'select',
    caption: 'Default Property',
    isUrl: true,
    validationRules: {
      isRequired: false
    },
  }
};
